import { Component } from '@angular/core';
import { I18nService } from '../../../services/i18n.service';

@Component({
	selector: 'app-language-switcher',
	templateUrl: './language-switcher.component.html',
	styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
	constructor(private i18nService: I18nService) {}

	get language() {
		return this.i18nService.supportedLanguages
			.find((l) => l === this.i18nService.language)
			.split('-')[0];
	}

	get languages() {
		return this.i18nService.supportedLanguages
			.filter((l) => l !== 'de-DE')
			.map((l) => {
				return { label: l.split('-')[0], value: l };
			});
	}

	setLanguage(event: Event, language: string) {
		event.preventDefault();
		if (language) {
			this.i18nService.setLanguage = language;
		}
	}
}
